<script setup lang="ts">
/**
 * @changelog
 *
 * 2026-03-11 (0.1.0) (jhoward)
 *   - Add PeppermillViewport.vue as a proxy for framework viewport.
 */ import PeppermillViewport from '@framework/components/layout/PeppermillViewport.vue';
import type { PropType } from 'vue';
import type { Router } from 'vue-router';
import localRouter from '@/router';

defineProps({
  isCardGrid: {
    type: Boolean,
    default: false,
  },
  includeBackButton: {
    type: Boolean,
    default: false,
  },
  router: {
    type: Object as PropType<Router | null>,
    default: null,
  },
});
</script>

<template>
  <peppermill-viewport
    :is-card-grid="isCardGrid"
    :include-back-button="includeBackButton"
    :router="router || localRouter"
  >
    <slot></slot>
  </peppermill-viewport>
</template>

<style scoped></style>
